import { Icon, Tile, TileCaption, TileImage } from '@mc/design-system'

import { Course } from 'types/data'
import Image from 'components/LegacyImage'

import { useAboutSectionVideo } from '../AboutSectionVideoContext'
import { trackTrailerVideoPlay } from '../events'

interface VideoSectionProps {
  series: Course
}

export const VideoSection = ({ series }: VideoSectionProps) => {
  const { videoId, mediaUuid, isPlaying, hasPlayed, toggleVideo, pageType } =
    useAboutSectionVideo()

  const getPlayingIcon = (id: string | undefined, uuid: string | undefined) =>
    isPlaying && (videoId === id || mediaUuid === uuid)
      ? 'pause'
      : 'play-circle'

  return (
    <Tile
      onClick={() => {
        toggleVideo(videoId, mediaUuid)
        trackTrailerVideoPlay({
          pageType,
          slug: series.slug,
          title: series.title,
          brightcoveVideoId: series.brightcoveVideoId,
          mediaUuid: series.mediaUuid,
        })
      }}
      className={`mc-corners--lg mc-overflow--hidden ${
        hasPlayed ? 'd-none' : ''
      }`}
    >
      <TileCaption position='center center'>
        <Icon
          kind={getPlayingIcon(videoId, mediaUuid)}
          className='mc-icon--8'
        />
      </TileCaption>
      {series.image16x9 && (
        <TileImage
          image={<Image alt='' src={series.image16x9} layout='fill' />}
        />
      )}
    </Tile>
  )
}
